import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import { OutreachAutomationType } from "../types";

const ACTIVATION_TIME_ESTIMATES: Record<OutreachAutomationType, string> = {
  bento_database: "about 10 minutes",
  google_places: "about 30 minutes",
  instagram_tracked_creators: "about an hour",
};

interface ActivationDialogProps {
  open: boolean;
  sourceType: OutreachAutomationType | null;
  onClose: () => void;
}

export default function ActivationDialog({
  open,
  sourceType,
  onClose,
}: ActivationDialogProps) {
  const estimate = sourceType
    ? ACTIVATION_TIME_ESTIMATES[sourceType]
    : "a little while";
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        Your automation is live!
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
          We're searching for your first brands now - this usually takes{" "}
          {estimate}. We'll send you an email once we've found some for you to
          review.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={onClose}>
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
}
